<template>
  <unicom-linha justificarItem="between">
    <unicom-coluna sm="12" md="11" style="padding-bottom: 24px">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Informações gerais
      </div>
    </unicom-coluna>
    <unicom-coluna sm="12" md="11">
      <div v-for="(componente, index) in listaComponentes" :key="index">
        <component
          v-model="accordionAtual"
          @elemento-atual="elementoAtual"
          @resetar-scroll="scrollarParaAccordion(elementoAtualAccordion)"
          :is="componente"
        />
      </div>
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import DadosGeraisPrestador from "./DadosGeraisPrestador/DadosGeraisPrestador";
import Qualificacao from "./Qualificacao/Qualificacao";
import DirecaoLideranca from "./DirecaoLideranca/DirecaoLideranca";
import Especialidades from "./Especialidades/Especialidades";
import Enderecos from "./Enderecos/Enderecos";
import Contatos from "./Contatos/Contatos";
import TotalLeitos from "./TotalLeitos/TotalLeitos";
import GrupoServico from "./GrupoServico/GrupoServico";
import RedesPreferenciadas from "./RedesPreferenciadas/RedesPreferenciadas";
import MotivoExclusao from "./MotivoExclusao/MotivoExclusao";

export default {
  components: {
    DadosGeraisPrestador,
    Qualificacao,
    DirecaoLideranca,
    Especialidades,
    Enderecos,
    Contatos,
    TotalLeitos,
    GrupoServico,
    RedesPreferenciadas,
    MotivoExclusao
  },
  data() {
    return {
      accordionAtual: "",
      elementoAtualAccordion: null
    };
  },
  methods: {
    elementoAtual(el) {
      this.elementoAtualAccordion = el;
      this.scrollarParaAccordion(el);
    },
    scrollarParaAccordion(el) {
      if (el === null) return;

      this.$scrollTo(el, 300, {
        container: this.$root.$children[0].$refs.main,
        offset: -20,
        lazy: false
      });
    }
  },
  activated() {
    this.$nextTick(() => {
      this.scrollarParaAccordion(this.elementoAtualAccordion);
    });
  },
  computed: {
    listaComponentes() {
      return [
        DadosGeraisPrestador,
        Qualificacao,
        DirecaoLideranca,
        Especialidades,
        Enderecos,
        Contatos,
        TotalLeitos,
        GrupoServico,
        RedesPreferenciadas,
        MotivoExclusao
      ];
    }
  }
};
</script>
